// extracted by mini-css-extract-plugin
export default {"splitSection":"styles_splitSection__XFpmg","formSection":"styles_formSection__bZMum","formField":"styles_formField__RDxhI"};